import { IBooking, SelectedBooking } from "../api/bookings/IBookings";
import { IFilterRequest } from "../api/bookings/filter/IFilterRequest";
import { statusTextMap } from "../const/statusText";
import { SearchType } from "../redux/slice/filterSlice";
import { SearchFilterState } from "../redux/types/searchFilterTypes";

export const convertStatusToText = (status: string): string => {
  return statusTextMap[status] || status;
};

export function convertIBookingToSelectedBooking(
  booking: IBooking
): SelectedBooking {
  return {
    id: booking.id, // Convert id from string to number.
    bookingValidations: booking.bookingValidations,
  };
}

export const convertSearchFilterToFilterRequest = (
  searchFilterState: SearchFilterState
): IFilterRequest => {
  const { selectedSearchFilter, searchArray, fromDate, toDate, fromTable } =
    searchFilterState;

  // Default FilterRequest object
  const filterRequest: IFilterRequest = {
    FromDate: fromDate ? fromDate.toDateString() : null,
    ToDate: toDate ? toDate.toDateString() : null,
    VesselName: null,
    ILUCode: null,
    UnitNumber: null,
    Status: [],
    ADR: null,
    POD: null,
    CustomerId: null,
    BookingIds: null,
  };
  // Process fromTable array
  if (fromTable)
    fromTable.forEach((item) => {
      switch (item.column) {
        case "STATUS":
          if (item.value === true) {
            filterRequest.Status = filterRequest.Status
              ? [...filterRequest.Status, item.label]
              : [item.label];
          }
          break;
        case "ADR":
          if (item.value !== null) {
            filterRequest.ADR = item.value as boolean;
          }
          break;
        case "VESSEL":
          filterRequest.VesselName =
            typeof item.value === "string" ? item.value : null;
          break;
        case "POD":
          filterRequest.POD =
            typeof item.value === "string" ? item.value : null;
          break;
        case "CUSTOMERNAME":
          filterRequest.CustomerId =
            typeof item.value === "string" ? parseInt(item.value) : null;
          break;
        // ... handle other columns similarly ...
      }
    });

  // Define a type for the keys in IFilterRequest that are arrays of strings
  type FilterArrayKeys = keyof Pick<IFilterRequest, "ILUCode" | "UnitNumber">;

  // Mapping from SearchType to the corresponding property in IFilterRequest
  const searchTypeToPropertyMap: { [key in SearchType]: FilterArrayKeys } = {
    [SearchType.UNITTYPE]: "UnitNumber",
    [SearchType.ILUCODE]: "ILUCode",
  };

  // Process searchArray if it's not empty
  if (searchArray.length > 0) {
    const searchKey = searchTypeToPropertyMap[selectedSearchFilter];
    if (searchKey) {
      // Ensure searchKey is not undefined
      const splitArray = searchArray
        .map((item) => item.split(","))
        .flat()
        .map((item) => item.trim()); // Split the searchArray string by commas and trim whitespace
      filterRequest[searchKey] = splitArray;
    }
  }

  // Ensure Status array is null if it's empty
  if (filterRequest.Status && filterRequest.Status.length === 0) {
    filterRequest.Status = null;
  }

  return filterRequest;
};

export const dateToStringConverter = (strDate: string) => {
  const date = new Date(strDate);
  return date.toISOString().split("T")[0];
};

export const convertFromBookingToSelectedBooking = (
  booking: IBooking
): SelectedBooking => {
  return {
    id: booking.id,
    bookingValidations: booking.bookingValidations,
  };
};
